// add upload media here as a service
import axios from 'axios';
import { store } from '../../redux/store';
import { baseURL } from '../../config';
import { uploadMediaTypes, uploadMediaOptionTypes } from './media.d';

const getToken = () =>
  store.getState().token?.token ||
  JSON.parse(
    JSON.parse(localStorage.getItem('persist:root') || '{}').token || '{}'
  ).token;

// بدلیل باگ ای پی آی کلاینت در فورم دیتا موقتا مستقیما با اَکسیوس مدیا رو میفرستیم.
export const uploadMedia = async (
  data: uploadMediaTypes,
  options: uploadMediaOptionTypes = {}
) => {
  const { endpoint = '/media/upload' } = options;
  const body = new FormData();
  for (const key in data)
    if (
      typeof key === 'string' &&
      data.hasOwnProperty(key) &&
      typeof data[key] !== 'undefined'
    )
      body.append(key, data[key]);

  return axios.post(`${baseURL}${endpoint}`, body, {
    headers: { t: getToken() },
  });
};
